import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import scheduledEventKeys from '@/api/queries/scheduleEvents/keyFactory';
import { graphql } from '@/gql';
import {
  UnlinkFolderEntryFromEventMutation,
  UnlinkFolderEntryFromEventMutationVariables,
} from '@/gql/graphql';

const UnlinkFolderEntryFromEvent = graphql(`
  mutation UnlinkFolderEntryFromEvent(
    $input: UnlinkFolderEntryFromEventInput!
  ) {
    unlinkFolderEntryFromEvent(input: $input)
  }
`);

const useUnlinkFolderEntryFromEvent = (args?: {
  eventId?: string | number;
  options?: UseMutationOptions<
    UnlinkFolderEntryFromEventMutation,
    unknown,
    UnlinkFolderEntryFromEventMutationVariables['input']
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UnlinkFolderEntryFromEvent, {
        input,
      });
    },
    onSuccess: () => {
      if (args?.eventId) {
        void queryClient.invalidateQueries({
          queryKey: scheduledEventKeys.scheduledEvent(args.eventId),
        });
      }
    },
    ...args?.options,
  });
};

export default useUnlinkFolderEntryFromEvent;
